import { render, staticRenderFns } from "./home-box8.vue?vue&type=template&id=7caae4f4&scoped=true&"
import script from "./home-box8.vue?vue&type=script&lang=js&"
export * from "./home-box8.vue?vue&type=script&lang=js&"
import style0 from "./home-box8.vue?vue&type=style&index=0&id=7caae4f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7caae4f4",
  null
  
)

export default component.exports